import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Redirect, useLocation } from 'react-router-dom';
import { useBreakpoint } from '@panel/commons';
import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import statusFailed from '../../../assets/img/statusFailed.svg';

const Container = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 600;
  & > div {
    white-space: normal;
    padding: 0 45px;
    ${withQuery.lg.down()} {
      margin-bottom: 30px;
    }
    & > img {
      width: 100%;
      max-width: 510px;
    }
  }
  ${withQuery.lg.down()} {
    flex-direction: column;
  }
`;

const Title = styled.h2`
  font-size: 4.2rem;
  color: ${select('negative')};
  line-height: 1;
  padding-top: 60px;
  ${withQuery.lg.down()} {
    font-size: 2rem;
  }
`;

const Text = styled.p`
  margin-top: 20px;
  color: ${select('violet')};
  line-height: 1.3;
  margin-bottom: 80px;
  ${withQuery.lg.down()} {
    font-weight: 500;
    margin-bottom: 40px;
  }
`;

const Button = styled.a`
  background: ${getColor('primary')};
  border-radius: 12px;
  padding: 10px 24px;
  color: ${select('white')};
  text-decoration: none;
  ${withQuery.lg.down()} {
    display: block;
    width: 80%;
    margin: 0 auto;
  }
`;
const StatusFailed = React.memo(props => {
  const [reachedBreakPoint] = useBreakpoint(1280);
  const { t } = useTranslation();
  const {
    state: { fromPreview }
  } = useLocation();

  if (!fromPreview) {
    return (
      <Redirect
        to={{
          pathname: '/avisos'
        }}
      />
    );
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  const titleKey = 'publisher.stepStatus.error.title.edition';
  const textKey = 'publisher.stepStatus.error.text.edition';
  return (
    <Container>
      {reachedBreakPoint && (
        <div>
          <Title data-repa='publishStatus-failed-title'>{t(titleKey)}</Title>
          <Text>{t(textKey)}</Text>
          <Button data-repa='publishStatus-failed-CTA' href='/panel/avisos'>
            {t('publisher.btn.linkToPostings')}
          </Button>
        </div>
      )}
      <div>
        <img src={statusFailed} alt={t('publisher.stepStatus.error.title')} />
      </div>
      {!reachedBreakPoint && (
        <div>
          <Title data-repa='publishStatus-failed-title-mobile'>{t(titleKey)}</Title>
          <Text>{t(textKey)}</Text>
          <Button data-repa='publishStatus-failed-CTA' href='/panel/avisos'>
            {t('publisher.btn.linkToPostings')}
          </Button>
        </div>
      )}
    </Container>
  );
});

export { StatusFailed };
